// Reducer for the details of a topic.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTopicDetailsState = {
  ...DefaultState
}

export const topicDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicDetailsState,
  actionRequest: ActionTypes.REQUEST_TOPIC_DETAILS,
  actionFailure: ActionTypes.REQUEST_TOPIC_DETAILS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPIC_DETAILS,
  actionInvalidate: ActionTypes.INVALIDATE_TOPIC_DETAILS
})
